<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="title"><a id="page_ia"></a><a id="page_i"></a>The Secret</h1>
<p class="subtitle"><strong>What Great Leaders Know and Do</strong></p>
<p class="author"><strong><span class="small">THIRD EDITION</span></strong></p>
<p class="author1"><strong>Ken Blanchard<br/>Mark Miller</strong></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?6d245cf3